export default __webpack_public_path__ + "static/media/AugDom2023.0576c728.jpg";